import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReadinessKpis } from '../../../models/college-dashboard.model';

@Component({
  selector: 'app-kpi-row',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './kpi-row.component.html',
  styleUrl: './kpi-row.component.scss'
})
export class KpiRowComponent {
  @Input() kpis: ReadinessKpis = {
    assessed: 0,
    averageScore: 0,
    ready: 0,
    developing: 0,
    atRisk: 0
  };
}
